import React from 'react';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

const MyTodosWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  return (
    <>
      {items.length === 0 && <WidgetEmpty>No open todos.</WidgetEmpty>}
      {items.map((t) => (
        <WidgetRow
          key={t.id}
          title={t.title}
          subtitle={t.category || (t.status === 'in_progress' ? 'In progress' : '')}
          right={t.is_overdue || t.due_label === 'Today'
            ? <Pill tone="error">{t.due_label}</Pill>
            : <Age>{t.due_label}</Age>}
          onClick={() => goTo(data.url)}
        />
      ))}
      <WidgetFooter label="Open todos" url={data.url} />
    </>
  );
};

export default MyTodosWidget;
